import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";
import { MissionsApiProvider } from "../providers/MissionsProvider";
import { useApiClient } from "./useApiClient";
/**
 * Query to fetch a mission by id
 * @param {number} id - The id of the mission
 * @returns UseQueryResult
 */
export function useMission(id, opts = {}) {
  const { user } = useContext(AuthContext);
  const { data: apiClient } = useApiClient();

  return useQuery({
    queryKey: ["user-mission", user, id],
    queryFn: async () => {
      return new MissionsApiProvider(apiClient).getMission(id);
    },
    enabled: Boolean(user) && Boolean(apiClient),
    refetchInterval: opts.refetchInterval || false,
  });
}

export function useRefreshMission() {
  const { data: apiClient } = useApiClient();

  return useMutation({
    mutationFn: async ({ missionId }) => {
      if (!apiClient) {
        throw new Error("API client is not defined");
      }
      new MissionsApiProvider(apiClient).refreshMissionTask(missionId);
    },
  });
}
